import type { ReactNode } from 'react'
import clsx from 'clsx'
import { AlertTriangle, Inbox } from 'lucide-react'
import { getApiErrorMessage } from '@/api/client'
import { Button } from '../Button/Button'
import styles from './State.module.scss'

export interface EmptyStateProps {
  title: string
  description?: ReactNode
  icon?: ReactNode
  action?: ReactNode
  compact?: boolean
  className?: string
}

export function EmptyState({ title, description, icon, action, compact, className }: EmptyStateProps) {
  return (
    <div className={clsx(styles.state, compact && styles.compact, className)}>
      <span className={styles.icon}>{icon ?? <Inbox size={20} />}</span>
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description}</div>}
      {action && <div className={styles.actions}>{action}</div>}
    </div>
  )
}

export interface ErrorStateProps {
  error?: unknown
  title?: string
  onRetry?: () => void
  compact?: boolean
  className?: string
}

export function ErrorState({ error, title = 'Could not load this section', onRetry, compact, className }: ErrorStateProps) {
  return (
    <div className={clsx(styles.state, compact && styles.compact, className)} role="alert">
      <span className={clsx(styles.icon, styles.iconError)}>
        <AlertTriangle size={20} />
      </span>
      <div className={styles.title}>{title}</div>
      {error !== undefined && <div className={styles.description}>{getApiErrorMessage(error)}</div>}
      {onRetry && (
        <div className={styles.actions}>
          <Button variant="secondary" size="sm" onClick={onRetry}>
            Try again
          </Button>
        </div>
      )}
    </div>
  )
}
